import React, { useState, useEffect, useCallback } from 'react';
import { FiClock } from 'react-icons/fi';
import API from 'shared/api';
import AsistenciaModal from './AsistenciaModal';
import { getQueueCount } from 'shared/attendanceQueue';

const S = {
  wrapper: { position: 'relative' },
  trigger: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '7px',
    padding: '7px 14px',
    borderRadius: '12px',
    border: 'none',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'all 0.2s',
  },
  dot: {
    width: '9px',
    height: '9px',
    borderRadius: '50%',
    display: 'inline-block',
    transition: 'all 0.2s',
  },
  dotActive: { background: '#16a34a', boxShadow: '0 0 0 3px rgba(22,163,74,0.15)' },
  dotInactive: { background: '#94a3b8' },
  active: { background: '#dcfce7', color: '#16a34a' },
  inactive: { background: '#f1f5f9', color: '#64748b' },
  pending: {
    background: '#f59e0b',
    color: '#fff',
    fontSize: '10px',
    fontWeight: 700,
    padding: '2px 6px',
    borderRadius: '8px',
    marginLeft: '2px',
    lineHeight: '14px',
  },
};

export default function AttendanceWidget() {
  const [open, setOpen] = useState(false);
  const [estado, setEstado] = useState(null);
  const [pendientes, setPendientes] = useState(0);

  const cargarEstado = useCallback(async () => {
    try {
      const r = await API.get('/asistencia/mi-estado');
      if (r.data.status === 'success') setEstado(r.data.data);
    } catch (e) {}
  }, []);

  useEffect(() => {
    cargarEstado();
    setPendientes(getQueueCount());
    const i = setInterval(() => setPendientes(getQueueCount()), 5000);
    return () => clearInterval(i);
  }, [cargarEstado]);

  const handleSuccess = () => {
    cargarEstado();
    setPendientes(getQueueCount());
  };

  const activo = estado?.activo;
  const ultimoLabel = estado?.ultimo_registro
    ? new Date(estado.ultimo_registro.hora_registro).toLocaleTimeString('es-VE', {
        hour: '2-digit',
        minute: '2-digit',
      })
    : '--:--';

  return (
    <div style={S.wrapper}>
      <button
        onClick={() => setOpen(true)}
        style={{ ...S.trigger, ...(activo ? S.active : S.inactive) }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-1px)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = '';
          e.currentTarget.style.boxShadow = 'none';
        }}
      >
        <span style={{ ...S.dot, ...(activo ? S.dotActive : S.dotInactive) }} />
        <FiClock size={14} />
        {ultimoLabel}
        {pendientes > 0 && <span style={S.pending}>{pendientes}</span>}
      </button>
      <AsistenciaModal
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={handleSuccess}
        miEstado={estado}
      />
    </div>
  );
}
